import { FigureFrame } from "./FigureFrame";
import type { ResearchFigureProps } from "./types";

const ink = "var(--figure-ink, currentColor)";
const accent = "var(--figure-accent, currentColor)";
const surface = "var(--figure-surface, transparent)";

export function OttFigure({
  className,
  caption,
  title = "Social media and OTT service use",
  description = "Analysis of 3,975 mobile app and web panel users finds complementary relationships between social media and OTT access and consumption, with differences by service model and consumer experience.",
}: ResearchFigureProps) {
  return (
    <FigureFrame
      className={className}
      caption={caption}
      title={title}
      description={description}
      viewBox="0 0 760 456"
    >
      <text x="32" y="36" fill={ink} fontSize="12" fontWeight="650" letterSpacing="1.6">
        MOBILE APP + WEB PANEL · N = 3,975
      </text>
      <line x1="32" y1="54" x2="728" y2="54" stroke={ink} strokeWidth="1.25" />

      <g fill={surface} stroke={ink} strokeWidth="1.25">
        <rect x="32" y="100" width="198" height="88" />
        <rect x="294" y="84" width="190" height="62" />
        <rect x="294" y="158" width="190" height="62" />
        <rect x="548" y="84" width="180" height="62" />
        <rect x="548" y="158" width="180" height="62" />
      </g>
      <g fill={ink} textAnchor="middle">
        <text x="131" y="133" fontSize="17" fontWeight="650">Social media use</text>
        <text x="131" y="159" fontSize="12">complementary relationship</text>
        <text x="389" y="122" fontSize="16" fontWeight="650">OTT access</text>
        <text x="389" y="196" fontSize="16" fontWeight="650">OTT consumption</text>
        <text x="638" y="112" fontSize="14" fontWeight="650">Free / ad-supported</text>
        <text x="638" y="132" fontSize="12" fill={accent}>stronger for access</text>
        <text x="638" y="186" fontSize="14" fontWeight="650">Paid</text>
        <text x="638" y="206" fontSize="12" fill={accent}>stronger for consumption</text>
      </g>
      <g fill="none" stroke={accent} strokeWidth="1.5">
        <path d="M 230 130 H 277 L 294 115" />
        <path d="M 230 158 H 277 L 294 189" />
        <path d="M 484 115 H 548" />
        <path d="M 484 189 H 548" />
      </g>
      <g fill={accent}>
        <circle cx="294" cy="115" r="3" />
        <circle cx="294" cy="189" r="3" />
        <circle cx="548" cy="115" r="3" />
        <circle cx="548" cy="189" r="3" />
      </g>

      <g transform="translate(32 286)">
        <text x="0" y="0" fill={ink} fontSize="12" fontWeight="650" letterSpacing="1.6">
          BOUNDARY CONDITIONS
        </text>
        <line x1="0" y1="18" x2="696" y2="18" stroke={ink} strokeWidth="1.25" />

        <text x="0" y="62" fill={ink} fontSize="15">Own OTT experience</text>
        <text x="696" y="62" fill={accent} fontSize="15" fontWeight="700" textAnchor="end">
          weakens the relationship
        </text>
        <line x1="0" y1="82" x2="696" y2="82" stroke={ink} strokeOpacity=".18" />

        <text x="0" y="124" fill={ink} fontSize="15">Peer experience</text>
        <text x="696" y="124" fill={accent} fontSize="15" fontWeight="700" textAnchor="end">
          strengthens free services only
        </text>
      </g>
    </FigureFrame>
  );
}
